import { Close, Timeline } from '@mui/icons-material';
import { Badge, Box, IconButton, Tooltip } from '@mui/material';
import { getRequestEvaluations } from 'lib/api';
import { cellFormat } from 'lib/designSystem/Table/cellFormat';
import { Evaluation } from 'lib/types/models';
import EvaluationHistoryDialog from 'pages/Finance/Components/Financing/common/Risk/EvaluationHistoryDialog';
import { buildRequestId } from 'pages/Finance/Components/Financing/common/utils';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

const TopHeader = ({
  selectedRequest,
  setOpenCloseModal,
}: {
  selectedRequest: { status: string };
  setOpenCloseModal: (open: boolean) => void;
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [latestEvaluation, setLatestEvaluation] = useState<Evaluation[]>([]);

  const getRiskEvaluation = async () => {
    setLoading(true);
    try {
      const response = await getRequestEvaluations(dispatch, {
        requestId: buildRequestId(
          selectedRequest,
          'factoring-request',
          'quote',
        ),
        requestType: 'factoring-request',
      });
      setLatestEvaluation(response.default);
    } catch (error) {
      console.error('Error fetching risk evaluations:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    void getRiskEvaluation();
  }, [selectedRequest]);

  if (selectedRequest?.status === 'Creando') {
    return (
      <IconButton aria-label="close" onClick={() => setOpenCloseModal(true)}>
        <Close />
      </IconButton>
    );
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Tooltip title="Acceso rápido a la última evaluación">
        <Badge
          badgeContent={latestEvaluation.length}
          color="primary"
          overlap="circular"
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <IconButton onClick={() => setDialogOpen(true)}>
            <Timeline fontSize="medium" />
          </IconButton>
        </Badge>
      </Tooltip>
      {cellFormat(selectedRequest?.status || 'Nuevo', 'status-chip')}
      {!loading && latestEvaluation && latestEvaluation.length > 0 && (
        <EvaluationHistoryDialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          riskData={latestEvaluation}
        />
      )}
    </Box>
  );
};

export default TopHeader;
